export default "__VITE_ASSET__DvfXrni1__"